import React from "react";

const ADO_Record = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Record</h1>
      <p>This is the ADO Record page content.</p>
    </div>
  );
};

export default ADO_Record;
